var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"codeElement",staticClass:"code",class:`language-${_vm.lang}`},[_c('code',{class:`language-${_vm.lang}`},[_vm._v(" "+_vm._s(_vm.code)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }